import { UtilBranchControllerGet200Response } from "@api/api";
import { GridItemModel } from "@core/ui/grid-item/grid-item";
import {
  GetResponseCampaignRewardModel,
  GetRewardCampaignModel,
} from "@factory/model/query-model-reward";
import { useQyGetBranch } from "@factory/query/branch.query";
import { viewAsset } from "@factory/query/google-cloud-storage.query";
import { useQyGetCampaignReward } from "@factory/query/reward.query";
import { LabelValue } from "@shared/models/label-value.interface";
import { useState } from "react";

export const useSphereRedeemItem = () => {
  // DECLARATIONS
  const [cardAlias, setCardAlias] = useState("");
  const [campaigns, setCampaigns] = useState<GetRewardCampaignModel[]>(); // Used for loading list of campaigns based on user
  const [selectedBranch, setSelectedBranch] = useState("");
  const [branchOptions, setBranchOptions] = useState<LabelValue[]>([]);
  const [selectedRedeemCampaign, setSelectedRedeemCampaign] =
    useState<GridItemModel | null>(null);

  // API
  const handleGetSuccess = async (data: GetResponseCampaignRewardModel) => {
    if (!data || data.data?.length === 0) {
      return;
    }
    const responseData = data.data as GetRewardCampaignModel[];

    if (responseData.length > 0) {
      const updatedResponse = await Promise.all(
        responseData.map(async (element) => {
          if (!element.image) {
            return element;
          }

          const elementFile = await viewAsset(element.image);
          const fileBlob = URL.createObjectURL(elementFile);
          return { ...element, image: fileBlob };
        })
      );
      setCampaigns(updatedResponse);
    }
  };
  const { mutate: getCampaign } = useQyGetCampaignReward(handleGetSuccess);

  const handleSuccess = (response: UtilBranchControllerGet200Response) => {
    const responseData = response?.data || [];
    if (responseData.length === 0) {
      return;
    }

    const _branchOption = LabelValue.MapArray(
      response?.data || [],
      (item) => item.name,
      (item) => item.code
    );

    setSelectedBranch(responseData?.[0].code);
    setBranchOptions(_branchOption);
  };
  useQyGetBranch("", 9999, 0, undefined, undefined, true, handleSuccess);

  return {
    campaigns,
    branchOptions,
    selectedBranch,
    selectedRedeemCampaign,
    cardAlias,
    setCardAlias,
    setSelectedRedeemCampaign,
    setSelectedBranch,
    getCampaign,
  };
};
